import React from 'react'

export default function SingleDiningPage() {
  return (
    <>
    <div className="single-dining-main">
        <img src="/images/hero_3.jpg" loading="lazy" alt="dining" />
        <span className='single-dining-span single-dining-span-desk '>DINNING</span>
    </div>

    
    </>
  )
}
